Vendd.Scripts.load(function () {

    initFaq();

    //faqNumber();
    function faqNumber() {
        var i = 1;
        $('.x-faq-list li').each(function () {
            $(this).find('.number').html(i + '.');
            i++;
        });
    }

    function initFaq() {
        var $wrapper = $('.x-faq-list');

        if ($wrapper.length < 1) {
            return;
        }

        var $question = $('.question', $wrapper);

        $question.click(function (e) {

            if (!$(this).siblings('.answer').hasClass('active')) {

                $('.active', $wrapper).stop(true, true).slideUp(200).removeClass('active').siblings().removeClass('open-faq icon-arrow-up').addClass('icon-arrow-down');

                $(this).siblings('.answer').addClass('active').stop(true, true).slideDown(200);

                $(this).addClass('open-faq icon-arrow-up').removeClass('icon-arrow-down').stop(true, true).slideDown(200);

            } else {

                $('.active', $wrapper).stop(true, true).slideUp(200).removeClass('active');

                $(this).removeClass('open-faq icon-arrow-up').addClass('icon-arrow-down').stop(true, true).slideDown(200);

            }

        });
    }
});